import axios, { AxiosInstance, RawAxiosRequestConfig } from 'axios';
import { ACCOUNT_ORIGIN } from '@model/const/account';

const getAPIAccount = (_context: any): AxiosInstance => {
    const defaults: RawAxiosRequestConfig = {
        timeout: 10000,
        baseURL: ACCOUNT_ORIGIN,
        withCredentials: true,
    };

    const instance = axios.create(defaults);
    // can wrap plugins here
    return instance;
};

export default getAPIAccount;
